import { notEmpty, type SourceReaderFunction } from '@festina-life/core'
import type { usePercentageFormatter } from '@festina-life/ui/hooks'
import * as Yup from 'yup'

import type { translations } from '../../../../translations/translations'
import { type AnyFractionVFrame, isRangeVFrame } from './types'

export const percentageValidation = ({
  frame,
  translate,
  formatPercentWithDecimals,
}: {
  frame: AnyFractionVFrame
  translate: SourceReaderFunction<(typeof translations)['en-GB']>
  formatPercentWithDecimals: ReturnType<
    typeof usePercentageFormatter
  >['formatPercentWithDecimals']
}) => {
  let percentage = Yup.number()

  const [min, max] = isRangeVFrame(frame)
    ? [frame.min, frame.max]
    : [undefined, undefined]

  const minMaxMessage =
    notEmpty(min) && notEmpty(max)
      ? translate('validation.between', {
          max: formatPercentWithDecimals(max, 2),
          min: formatPercentWithDecimals(min, 2),
        })
      : undefined

  if (notEmpty(min)) {
    percentage = percentage.min(
      min,
      minMaxMessage ??
        translate('validation.min', {
          min: formatPercentWithDecimals(min, 2),
        }),
    )
  }

  if (notEmpty(max)) {
    percentage = percentage.max(
      max,
      minMaxMessage ??
        translate('validation.max', {
          max: formatPercentWithDecimals(max, 2),
        }),
    )
  }

  return percentage
}
